/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocCertIcon24Solid = forwardRef('DocCertIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.05 2H8a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h4v2.17a.8.8 0 0 0 1.261.654l1.124-.793a.2.2 0 0 1 .23 0l1.124.793A.8.8 0 0 0 17 23.171v-2.297c1.725-.444 3-2.01 3-3.874v-6.95h-5.2a2.75 2.75 0 0 1-2.75-2.75V2Zm5.075 14.5a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" }),
        React.createElement("path", { d: "m20 8.55-6.45-6.49V7.3c0 .69.56 1.25 1.25 1.25H20Z" })));
});
